import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ProjectConstants} from 'src/app/project-constants';
import {FormControl} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {UsersAnagrafService} from 'src/app/general-services/service-users-anagraf/users-anagraf.service';
import {UserModel} from 'src/models/UserModel';
import {map, startWith} from 'rxjs/operators';

@Component({
  selector: 'app-user-username-filter',
  templateUrl: './user-username-filter.component.html',
  styleUrls: ['./user-username-filter.component.scss']
})
export class UserUsernameFilterComponent extends ProjectConstants implements OnInit, OnDestroy {


  listFilterUsernames: any[];

  usernamesFormControl = new FormControl();
  usernamesFilteredOptions: Observable<any[]>;

  getAllUsers: Subscription;

  @Output() dataFiltered = new EventEmitter<any>();

  constructor(private usersService: UsersAnagrafService) {
    super();
    this.getAll();
  }

  ngOnInit() {
  }

  filterTable(): void {
    const filter: UserModel = new UserModel();

    filter.username = this.usernamesFormControl.value;

    this.dataFiltered.emit(filter);
  }

  getAll() {
    this.getAllUsers = this.usersService.getAll(this.usersService.baseUrl, null)
      .subscribe(
        (result: any) => {
          this.listFilterUsernames = result;
          this.usernamesFormControl.setValue(null);
          this.applyUserFormControlFilteredOptions();
        }
      );
  }

  // AUTOCOMPLETE Units

  applyUserFormControlFilteredOptions() {
    this.usernamesFilteredOptions = this.usernamesFormControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterUsersOptionList(value))
      );
  }

  displayUsernamesAutocompleteFn(element: any) {
    if (element) {
      return element.username;
    }
  }

  ngOnDestroy(): void {
  }

  private _filterUsersOptionList(value: string): string[] {
    if (value === '') {
      this.usernamesFormControl.setValue(null);
    }

    if (value === null) {
      value = '';
    } else if (typeof value !== 'string') {
      return null;
    }

    return this.listFilterUsernames.filter(option => {
      if (option.username.toLowerCase().includes(value.toLowerCase())) {
        return option;
      }
    });
  }

}
